import { FormattedMessage } from 'react-intl';
import { Button, Modal, ModalContent, ModalFooter, ModalLayout, ModalTitle } from '@tlx/atlas';
import { createOrdinalFromArray } from '@Util/misc.ts';

type Props = {
    handleClose: React.Dispatch<React.SetStateAction<boolean>>;
    closeDialogAndRedirect: () => void;
    maxNumberEmployees: number;
    numberEmployees: number;
    numberTransactions: number;
};

export function CreateSalaryModalInformSeveral({
    handleClose,
    closeDialogAndRedirect,
    maxNumberEmployees,
    numberEmployees,
    numberTransactions,
}: Props) {
    return (
        <Modal
            open={true}
            onClose={() => {
                handleClose(false);
            }}
            className={'tsk-width-500'}
        >
            <ModalLayout>
                <ModalTitle>
                    <FormattedMessage id={'text_information'} />
                </ModalTitle>
                <ModalContent>
                    <FormattedMessage
                        id={'text_wage_transaction_split_inform_after'}
                        values={createOrdinalFromArray([maxNumberEmployees, numberEmployees, numberTransactions])}
                    />
                </ModalContent>
                <ModalFooter className={'atl-flex atl-gap-8'}>
                    <Button
                        className="atl-button--primary"
                        data-testid="create-salary-run-button"
                        type={'submit'}
                        onClick={closeDialogAndRedirect}
                    >
                        <FormattedMessage id={'text_ok'} />
                    </Button>
                </ModalFooter>
            </ModalLayout>
        </Modal>
    );
}
